// extracted by mini-css-extract-plugin
export default {"sidebar-link":"Menu_sidebar-link__fQY6W","sidebar-link_text":"Menu_sidebar-link_text__BknY9","active":"Menu_active__YO+RX","main-nav":"Menu_main-nav__XVnoN"};